module.exports = __webpack_public_path__ + "media/images/brand/app_logo_full_topbar-6847fd7c8b96c271055560f1c34d3ec9.png";